import ClipboardJS from 'clipboard'

Ready(() => {
  new ClipboardJS('[data-clipboard-text]')
})
